import { useQueryClient } from "@tanstack/react-query";

import { usePostTestingControlsBulk } from "api/generated/testing-controls/testing-controls";

import { TESTING_CONTROLS_QUERY_KEY } from "../../list/queries/useTestingProgramTestingControlsQuery";

export function useCreateBulkTestingControlMutation() {
    const queryClient = useQueryClient();
    return usePostTestingControlsBulk({
        mutation: {
            onSuccess: () => {
                queryClient.invalidateQueries({
                    queryKey: [TESTING_CONTROLS_QUERY_KEY],
                });
            },
        },
    });
}
